let isAllowToFormat = true
let beforeValue = null
export default {
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            amount: '',
        }
    },
    mounted() {
        if (this.value) {
            this.amount = this.formatNumber(this.value)
        }
        // Select all inputs with the data-type='currency' attribute
        this.currencyInputs = document.querySelectorAll(
            "input[data-type='currency']"
        )

        // Attach event listeners for the 'keyup' and 'blur' events
        this.currencyInputs.forEach((input) => {
            input.addEventListener('keydown', this.handleKeyDown)
            input.addEventListener('keyup', this.handleKeyUp)
            input.addEventListener('blur', this.handleBlur)
        })
    },
    beforeDestroy() {
        // Clean up event listeners when the component is destroyed
        this.currencyInputs.forEach((input) => {
            input.removeEventListener('keydown', this.handleKeyDown)
            input.removeEventListener('keyup', this.handleKeyUp)
            input.removeEventListener('blur', this.handleBlur)
        })
    },
    methods: {
        handleKeyDown(event) {
            isAllowToFormat = true
            const validKeyPattern = /^[0-9.]/g
            const inputValue = event.target.value
            beforeValue = inputValue
            const isControlKey =
                event.key === 'Backspace' ||
                event.key === 'Tab' ||
                event.key === 'ArrowLeft' ||
                event.key === 'ArrowRight' ||
                event.key === 'Enter' ||
                event.key === 'Delete' ||
                event.key === 'Home' ||
                event.key === 'End' ||
                event.key === 'Escape' ||
                event.ctrlKey ||
                event.metaKey ||
                event.altKey

            if (isControlKey) {
                isAllowToFormat = false
            }
            if (event.target.value.includes('.') && event.key === '.') {
                return event.preventDefault()
            }

            if (!(isControlKey || validKeyPattern.test(event.key))) {
                return event.preventDefault()
            }
            // Check if the key is try to append the existing value
            if (inputValue.includes('.')) {
                const decimalPos = inputValue.indexOf('.')
                const rightSide = inputValue.substring(decimalPos)
                const caretPos = event.target.selectionStart
                if (
                    rightSide?.length === 3 &&
                    (caretPos === inputValue?.length ||
                        caretPos === inputValue?.length - 1 ||
                        caretPos === inputValue?.length - 2)
                ) {
                    if (!isControlKey) {
                        return event.preventDefault()
                    }
                }
            }
        },
        handleKeyUp(event) {
            const isValueChange = beforeValue !== event.target.value
            if (isAllowToFormat || isValueChange) {
                this.formatCurrency(event.target)
            } else if (!event.target.value) {
                this.$emit('input', '')
                this.amount = ''
            }
        },
        handleBlur(event) {
            if (event.target.value?.endsWith('.')) {
                event.target.value = event.target.value?.replace('.', '')
            }
            this.formatCurrency(event.target, 'blur')
        },
        formatNumber(n) {
            return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        formatCurrency(input, blur = '') {
            let inputVal = input.value

            // Don't validate empty input
            if (inputVal === '') {
                this.$emit('input', inputVal?.replaceAll(',', ''))
                this.amount = inputVal
                return
            }

            // Store the original input length
            const originalLength = inputVal.length

            // Store the initial caret position
            let caretPos = input.selectionStart

            // Check for decimal
            if (inputVal.includes('.')) {
                const decimalPos = inputVal.indexOf('.')

                // Split number by decimal point
                let leftSide = inputVal.substring(0, decimalPos)
                let rightSide = inputVal.substring(decimalPos)

                // Add commas to left side of number
                leftSide = this.formatNumber(leftSide)

                // Validate right side
                rightSide = this.formatNumber(rightSide)

                // On blur, make sure 2 numbers after the decimal
                if (blur === 'blur') {
                    // rightSide += '00'
                }

                // Limit decimal to only 2 digits
                rightSide = rightSide.substring(0, 2)

                // Join number with a dot
                inputVal = '' + leftSide + '.' + rightSide
            } else {
                // No decimal entered
                // Add commas to number and remove all non-digits
                inputVal = this.formatNumber(inputVal)
                inputVal = '' + inputVal

                // Final formatting on blur
                if (blur === 'blur') {
                    inputVal += '.00'
                }
            }

            // Set the formatted value back to the input
            input.value = inputVal
            this.$emit('input', inputVal?.replaceAll(',', ''))
            this.amount = inputVal

            // Reposition the caret
            const updateLen = inputVal.length
            caretPos = updateLen - originalLength + caretPos
            input.setSelectionRange(caretPos, caretPos)
        },
        resetValue(value = null) {
            this.amount = value ?? ''
            this.$emit('input', value ?? '')
        },
    },
}
